import Card from "../../UI/Card";
import Callout from "../../UI/Callout";
import useMandatPrelevementFichier from "../../../hooks/use-mandat-prelevement-fichier";
import DocumentDownloadLink from "../../UI/DocumentDownloadLink";
import { useState } from "react";
import { currencyFormatter } from "../../../api/Functions";
import { handleAPIError } from "../../../utils/index.jsx";
import { Form, Formik } from "formik";
import {
  MANDAT_PRELEVEMENT_FICHIER_IV,
  mandatPrelevementFichierSchema,
} from "../../../models/mandatPrelevement";
import FormikSubmitButton from "../../UI/FormikSubmitButton";
import TextInput from "../../UI/TextInput";
import { sanitizeValues } from "../../../models/utils";

export default function FichierPrelevementForm({
  selectedTenants,
  amountsByTenant,
}) {
  const [error, setError] = useState("");
  const { createMandatPrelevementFichier } = useMandatPrelevementFichier();
  const [files, setFiles] = useState([]);

  async function handleSubmit(values) {
    const { date_prelevement: datePrelevement } = sanitizeValues(values);
    const tenantIds = selectedTenants.map((tenant) => tenant.id);
    const selectedAmountsByTenant = Object.fromEntries(
      Object.entries(amountsByTenant).filter(([key]) =>
        tenantIds.includes(Number(key)),
      ),
    );

    try {
      const response = await createMandatPrelevementFichier({
        amountsByTenant: selectedAmountsByTenant,
        datePrelevement,
      });
      setFiles(response);
    } catch (error) {
      console.error(error);
      setError(handleAPIError(error));
    }
  }

  return (
    <Formik
      initialValues={MANDAT_PRELEVEMENT_FICHIER_IV}
      onSubmit={handleSubmit}
      validationSchema={mandatPrelevementFichierSchema}
    >
      <Form>
        <div>
          <h2 className={"text-center"}>Fichier de prélèvement</h2>
          <p className={"marginB10"}>
            En cliquant sur "Générer le fichier", un fichier SEPA au format XML
            sera généré par profil bailleur pour les locataires et les montants
            ci-dessous.
          </p>
          <div className={"flex wrap gap10"}>
            {files.map((downloadUrl, i) => (
              <DocumentDownloadLink
                save
                downloadUrl={downloadUrl}
                mimetype={"application/xml"}
                key={i}
              ></DocumentDownloadLink>
            ))}
          </div>
          <TextInput
            type={"date"}
            name={"date_prelevement"}
            label={"Date de prélèvement"}
            mandatory
          />
          {selectedTenants.map((tenant, i) => {
            return (
              <Card
                key={i}
                padding={"sm"}
                className={"flex space-between marginT5"}
              >
                <p>{tenant.nom}</p>
                <p>
                  {currencyFormatter(parseFloat(amountsByTenant[tenant.id]))}
                </p>
              </Card>
            );
          })}
          <div className={"text-right marginT10"}>
            <FormikSubmitButton>Générer le fichier</FormikSubmitButton>
          </div>
          <Callout variant="danger">{error}</Callout>
        </div>
      </Form>
    </Formik>
  );
}
